package com.loyola.acessoescola.ui.addnew

class InvalidCPFException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)


class InvalidPhoneException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)


class EmptyFieldException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)